
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 1.06h6.879a1.5 1.5 0 0 1 1.06.439L22.5 11.56M9.129 4.06H3a1.5 1.5 0 0 0-1.5 1.5v6.128a1.5 1.5 0 0 0 .439 1.061l9.75 9.75a1.5 1.5 0 0 0 2.122 0l6.128-6.129a1.5 1.5 0 0 0 0-2.121L10.189 4.5a1.5 1.5 0 0 0-1.06-.44Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6 8.185a.375.375 0 1 0 .375.375A.374.374 0 0 0 6 8.185h0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    